import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, inject } from "@angular/core"
import { IconImageService } from "@shared/services/icon-image.service"

@Component({
    selector: "flow-pill",
    templateUrl: "./flow-pill.component.html",
    styleUrl: "./flow-pill.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FlowPillComponent {
  iconService = inject(IconImageService)

  @Input() label: string = ""
  @Input() active: boolean = false
  @Input() disabled: boolean = false
  @Input() icon: string = this.iconService.Icon.plus
  @Input() width: string | number | null = null
  @Output() pillClick = new EventEmitter<void>()

  public get pillWidth(): string | null {
    if (this.width === null || this.width === "") return null
    return typeof this.width === "number" ? `${this.width}px` : this.width
  }

  public onClick(): void {
    if (this.disabled) return
    this.pillClick.emit()
  }
}
